import { useQuery } from '@apollo/client/react';
import { GET_VENDOR_EARNINGS } from 'api/graphql/account';
import { useVendor } from 'features/vendor';

/** Month enum values accepted by the earnings query (`MonthEnum`). */
export const MONTHS = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
];

/** Fetches the vendor's earnings for a given month/year. */
export function useVendorEarnings({ month, year, inStore = false }) {
  const { vendorId, loading: vendorLoading } = useVendor();

  const { data, loading, error, refetch } = useQuery(GET_VENDOR_EARNINGS, {
    variables: { vendorId, month, year, inStore },
    skip: !vendorId || !month || !year,
    notifyOnNetworkStatusChange: true,
  });

  // `getVendorEarnings` returns a LIST (one summary entry per vendor/period).
  // We query a single shop + month + year, so unwrap the first entry.
  const list = data?.getVendorEarnings;
  const earnings = Array.isArray(list) ? list[0] ?? null : list ?? null;

  return {
    earnings,
    loading: vendorLoading || loading,
    error,
    refetch,
  };
}
